var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.viewTitle)?[_c('h2',{staticClass:"pb-3 font-weight-regular"},[_vm._v(_vm._s(_vm.computedTitle))]),_c('h1',{staticClass:"pb-1 text-no-wrap"},[_vm._v(_vm._s(_vm.viewTitle))])]:_c('h1',{staticClass:"pb-3"},[_vm._v(_vm._s(_vm.computedTitle))]),_vm._v(" "+_vm._s(_vm.description)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }